import { render, staticRenderFns } from "./veStuCaucusUser.vue?vue&type=template&id=fc9c7b64&scoped=true"
import script from "./veStuCaucusUser.vue?vue&type=script&lang=js"
export * from "./veStuCaucusUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9c7b64",
  null
  
)

export default component.exports